import { render, staticRenderFns } from "./AddBills.vue?vue&type=template&id=5944241a&scoped=true"
import script from "./AddBills.vue?vue&type=script&lang=js"
export * from "./AddBills.vue?vue&type=script&lang=js"
import style0 from "./AddBills.vue?vue&type=style&index=0&id=5944241a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944241a",
  null
  
)

export default component.exports